import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getLatestValidStepIndex } from '../../store/store';
import { formStepRoutes } from '../routes';

export const FormGuard = () => {
  const location = useLocation();
  const latestValidIndex = getLatestValidStepIndex();
  const currentStepIndex = formStepRoutes.findIndex((step) => step.path === location.pathname);
  const params = new URLSearchParams(window.location.search);

  if (params.get('mn') && (currentStepIndex < latestValidIndex || location.pathname === '/')) {
    return <Navigate to={formStepRoutes[latestValidIndex].path} replace />;
  }

  if (currentStepIndex === -1 || currentStepIndex > latestValidIndex) {
    return <Navigate to={formStepRoutes[latestValidIndex].path} replace />;
  }

  return <Outlet />;
};
